import type { SlotDefinition } from "./types";

/**
 * Rocket blueprint slots — positions are center offsets from rocket origin (grid units).
 * Origin sits at the engine center; rocket grows upward (negative Y).
 * Vertical edges are flush: engine top meets body bottom, body top meets nose bottom.
 */
export const ROCKET_SLOTS: SlotDefinition[] = [
  {
    id: "slot-nose",
    label: "Nose cone",
    accepts: "nose",
    offsetX: 0,
    offsetY: -5,
    dimensions: { gridW: 2, gridH: 2 },
    zIndex: 10,
  },
  {
    id: "slot-body",
    label: "Fuselage",
    accepts: "fuselage",
    offsetX: 0,
    offsetY: -2.5,
    dimensions: { gridW: 2, gridH: 3 },
    zIndex: 5,
  },
  {
    id: "slot-window",
    label: "Window",
    accepts: "window",
    offsetX: 0,
    offsetY: -2.5,
    dimensions: { gridW: 1, gridH: 1 },
    zIndex: 15,
    requiresSlot: "slot-body",
  },
  {
    id: "slot-engine",
    label: "Engine",
    accepts: "engine",
    offsetX: 0,
    offsetY: 0,
    dimensions: { gridW: 2, gridH: 2 },
    zIndex: 4,
  },
  {
    id: "slot-fin-left",
    label: "Left fin",
    accepts: "fin",
    offsetX: -1.5,
    offsetY: 0,
    dimensions: { gridW: 1, gridH: 2 },
    zIndex: 3,
  },
  {
    id: "slot-fin-right",
    label: "Right fin",
    accepts: "fin",
    offsetX: 1.5,
    offsetY: 0,
    dimensions: { gridW: 1, gridH: 2 },
    zIndex: 3,
  },
  {
    id: "slot-booster-left",
    label: "Left booster",
    accepts: "booster",
    offsetX: -1.5,
    offsetY: -2.5,
    dimensions: { gridW: 1, gridH: 3 },
    zIndex: 2,
  },
  {
    id: "slot-booster-right",
    label: "Right booster",
    accepts: "booster",
    offsetX: 1.5,
    offsetY: -2.5,
    dimensions: { gridW: 1, gridH: 3 },
    zIndex: 2,
  },
];

export const SLOT_BY_ID = Object.fromEntries(
  ROCKET_SLOTS.map((s) => [s.id, s]),
) as Record<string, SlotDefinition>;
